import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../../styles/Layout/Header.css';

const Header = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const toggleNav = () => setIsNavCollapsed(prev => !prev);
  const closeNav = () => setIsNavCollapsed(true);

  return (
    <header className="header">
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container">
          <Link className="navbar-brand" to="/" onClick={closeNav}>
            <div className="logo-container">
              <div className="logo-text">
                <img
                  src="images/logo3.png"
                  alt="Pentagram Infotech"
                />
              </div>
            </div>
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleNav}
            aria-expanded={!isNavCollapsed}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`navbar-collapse ${isNavCollapsed ? 'collapse' : 'show'}`}>
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" onClick={closeNav}>Home</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/industries" onClick={closeNav}>Industries</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/services" onClick={closeNav}>Services</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/about" onClick={closeNav}>About</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/contact" onClick={closeNav}>Contact</NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
